import React from 'react'
import './Footer.css'
import { useTranslation } from 'react-i18next';

function Footer() {
   const { t, i18n } = useTranslation();
        
            const changeLanguage = (e) => {
              i18n.changeLanguage(e.target.value);
          };
  return (
    <>
      <div className='Footer_container' >

        <div className='Fsection1' >
          <img src='/assets/Logo/Logo_medrassa.png' alt='logo' />
        </div>

        <div className='Fsection2 ' >
          <h1 className='titre'>{t('footer.title')}</h1>
          {/* <p><strong>Telephone</strong></p>
          <p>+212 524 38 41 12</p> */}
          <p className='plf'><strong>{t('footer.email')}</strong></p>
          <p className='plf'>{t('footer.email_value')}</p>
          <p className='plf'><strong>{t('footer.adresse')}</strong></p>
          <p className='plf'>{t('footer.adresse_value')}</p> 
        </div>

        <div className='Fsection3'>
          <img src='/assets/Logo/Logo_m.png' alt='logo' />
          <p className='plf'>{t('footer.paragraph')}</p>
        </div>

      </div>
    </>

  )
}

export default Footer